import React from 'react';
import {Link} from 'react-router';
export default class RowItemDocumentDetail extends React.Component {

  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>{this.props.item.documentname}</td>
        <td>{this.props.item.countpage}</td>
        <td>{this.props.item.doucmenttype}</td>
        <td>
          <Link>{this.props.item.fileattach}</Link>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/reception/datatable/add/RowItemDocumentDetail.jsx